import React, { Component } from 'react';
import { View, Image, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import ScrollableTabView from "../../components/ui/ScrollableTabView";
import EmojiManager from '../../utils/EmojiManager';

function noGetFocus(e) {
    if (e.preventDefault) {
        // 防止按钮获取焦点, 让输入框保持焦点
        e.preventDefault();
    }
}

class EmojiSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
        };
        this.groups = [
            {
                icon: require('./images/emoji/smile.png'),
                items: ['😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '😗', '😙', '😚', '☺️', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴', '😌', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🤑', '😲', '☹️', '🙁', '😖', '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '🤯', '😬', '😰', '😱', '😳', '🤪', '😵', '😡', '😠', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '😇', '🤠', '🤡', '🤥', '🤫', '🤭', '🧐', '🤓', '😈', '👿', '👹', '👺', '💀', '👻', '👽', '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙈', '🙉', '🙊', '💋', '💌', '💘', '💝', '💖', '💗', '💓', '💞', '💕', '💟', '💔', '🤲', '👐', '🙌', '👏', '🤝', '👍', '👎', '👊', '✊', '🤛', '🤜', '🤞', '✌️', '🤟', '🤘', '👌', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖖', '🤙', '💪', '🖕', '✍️', '🙏'],
            },
            {
                icon: require('./images/emoji/users.png'),
                items: ['🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻', '🧠', '🫀', '🫁', '🦷', '🦴', '👀', '👅', '👄', '👶', '🧒', '👦', '👧', '🧑', '👱', '👨', '🧔', '👩', '🧓', '👴', '👵', '🙍', '🙎', '🙅', '🙆', '💁', '🙋', '🧏', '🙇', '🤦', '🤷', '👮', '💂', '🥷', '👷', '🤴', '👸', '👳', '👲', '🧕', '🤵', '👰', '🤰', '🤱', '👼', '🎅', '🤶', '🦸', '🦹', '🧙', '🧚', '🧛', '🧜', '🧝', '🧞', '🧟', '💆', '💇', '🚶', '🧍', '🧎', '🏃', '💃', '🕺', '👯', '🧖', '🧗', '🤺', '🏇', '🏂', '🏄', '🚣', '🏊', '🚴', '🚵', '🤸', '🤼', '🤽', '🤾', '🤹', '🧘', '🛀', '🛌', '👭', '👫', '👬', '💏', '💑', '👪', '👤', '👥', '🫂', '👣'],
            },
            {
                icon: require('./images/emoji/pizza.png'),
                items: ['🍇', '🍈', '🍉', '🍊', '🍋', '🍌', '🍍', '🥭', '🍎', '🍏', '🍑', '🍒', '🍓', '🫐',  '🥝', '🍅', '🫒',  '🥥', '🥑', '🍆', '🥔', '🥕', '🌽', '🫑', '🥒', '🥬', '🥦', '🧄', '🧅', '🍄', '🥜', '🌰', '🍞', '🥐', '🥖', '🫓', '🥨', '🥯', '🥞', '🧇', '🧀', '🍖', '🍗', '🥩', '🥓', '🍔', '🍟', '🍕', '🌭', '🥪', '🌮', '🌯', '🫔', '🥙', '🧆', '🥚', '🍳', '🥘', '🍲', '🫕', '🥣', '🥗', '🍿', '🧈', '🧂', '🥫', '🍱', '🍘', '🍙', '🍚', '🍛', '🍜', '🍝', '🍠', '🍢', '🍣', '🍤', '🍥', '🥮', '🍡', '🥟', '🥠', '🥡', '🦀', '🦞', '🦐', '🦑', '🦪', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂', '🍰', '🧁', '🥧', '🍫', '🍬', '🍭', '🍮', '🍯', '🍼', '🥛', '☕', '🫖', '🍵', '🍶', '🍾', '🍷', '🍸', '🍹', '🍻', '🥂', '🥃', '🥤', '🧋', '🧃', '🧉', '🧊', '🥢', '🍴', '🥄', '🔪', '🏺'],
            },
            {
                icon: require('./images/emoji/trees.png'),
                items: ['🐵', '🐒', '🦍', '🦧', '🐕', '🦮', '🐕', '🦺', '🐩', '🐺', '🦊', '🦝', '🐱', '🐈', '🐈', '🦁', '🐯', '🐅', '🐆', '🦄', '🦓', '🦌', '🦬', '🐂', '🐃', '🐄', '🐷', '🐖', '🐗', '🐽', '🐏', '🐑', '🐐', '🐪', '🐫', '🦙', '🦒', '🐘', '🦣', '🦏', '🦛', '🐭', '🐁', '🐀', '🐹', '🐰', '🐇', '🦫', '🦔', '🦇', '🐨', '🐼', '🦥', '🦦', '🦨', '🦘', '🦡', '🐾', '🦃', '🐔', '🐓', '🐣', '🐤', '🐥', '🐦', '🦅', '🦆', '🦢', '🦉', '🦤', '🪶', '🦩', '🦚', '🦜', '🐸', '🐊', '🦎', '🐍', '🐲', '🐉', '🦕', '🦖', '🐳', '🐋', '🐬', '🦭', '🐟', '🐡', '🦈', '🐙', '🐚', '🐌', '🦋', '🐜', '🐝', '🪲', '🐞', '🦗', '🪳', '🦂', '🦟', '🪰', '🪱', '🦠', '💐', '🌸', '🌹', '🥀', '🌺', '🌻', '🌼', '🌷', '🌱', '🪴', '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '🍀', '🍁', '🍂', '🍃'],
            },
            {
                icon: require('./images/emoji/football.png'),
                items: ['🎃', '🎄', '🎆', '🎇', '🧨', '✨', '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎑', '🧧', '🎀', '🎁', '🏆', '🏅', '🥇', '🥈', '🥉', '⚾', '🥎', '🏐', '🏈', '🏉', '🎾', '🥏', '🎳', '🏏', '🏑', '🏒', '🥍', '🏓', '🏸', '🥊', '🥋', '🥅', '⛳', '🎣', '🤿', '🎽', '🎿', '🛷', '🥌', '🎯', '🪀', '🪁', '🎱', '🔮', '🪄', '🧿', '🎮', '🎰', '🎲', '🧩', '🧸', '🪅', '🪆', '🃏', '🀄', '🎴', '🎭', '🎨', '🧵', '🪡', '🧶', '🪢'],
            },
            {
                icon: require('./images/emoji/plane.png'),
                items: ['🚗', '🚕', '🚙', '🚌', '🚎', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🛴', '🚲', '🛵', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬', '💺', '🚀', '🛸', '🚁', '🛶', '🚤', '🚢', '🚧', '🚦', '🚥', '🚏', '🗿', '🗽', '🏰', '🏯', '🎡', '🎢', '🎠', '🌋', '🗻', '🏠', '🏡', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🕌', '🕍', '🕋', '🗾', '🎑', '🌅', '🌄', '🌠', '🎇', '🎆', '🌇', '🌆', '🌃', '🌌', '🌉', '🌁'],
            },
        ];
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.width !== nextState.width) {
            return true;
        }
        return false;
    }

    _onSelect = (item) => {
        if (this.props.onSelect) {
            this.props.onSelect(item);
        }
    };

    _onLayout = (e) => {
        const width = e.nativeEvent.layout.width;
        if (width !== this.state.width) {
            this.setState({width: width});
        }
    };

    _renderTab = (name, page, isTabActive, onPressHandler) => {
        return (<View style={{marginRight: 8, marginTop: 8, marginBottom: 8}}>
                    <TouchableOpacity key={page}
                                      style={{flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                              backgroundColor: (isTabActive ? '#4a91f4' : 'transparent'),
                                              padding: 4, borderRadius: 6}}
                                      onPress={() => onPressHandler(page)}>
                        <Image style={isTabActive ? styles.iconact : styles.icon} source={name}/>
                    </TouchableOpacity>
                </View>);
    };

    _renderTabBar = (props) => {
        return (<View style={{flexDirection: 'row', alignItems: 'center',
                              backgroundColor: 'transparent'}}>
                    {props.tabs.map((name, page) => {
                        const isTabActive = props.activeTab === page;
                        return this._renderTab(name, page, isTabActive, props.goToPage);
                    })}
                </View>);
    };

    _renderItem = (item, i) => {
        const url = EmojiManager.getImage(item);
        if (url) {
            return (<TouchableOpacity key={i} style={styles.imgbox}
                                      onPress={() => this._onSelect(item)}>
                        <Image style={styles.image} source={{uri: url}}/>
                    </TouchableOpacity>);
        }
        return (<TouchableOpacity key={i} style={styles.imgbox} disabled={true}>
                    <Image style={styles.image} source={require('./images/emoji/questionMark.png')}/>
                </TouchableOpacity>);
    };

    _renderGroup = (group, i) => {
        const items = group.items;
        return (
            <ScrollView key={i} tabLabel={group.icon}>
                <View style={styles.tabview}>
                    {items.map(this._renderItem)}
                </View>
            </ScrollView>
        );
    };

    render() {
        const { style } = this.props;
        return (<View style={{backgroundColor: '#f9fafb', paddingLeft: 10, paddingRight: 10, ...style}}
                      onMouseDown={noGetFocus} onLayout={this._onLayout}>
                    {this.state.width ?
                     (<ScrollableTabView style={{flex: 1}} headerView={true} lazyRender={true}
                                         tabBarWidth={this.state.width} underlineWidth={60}
                                         tabBarPosition='top'
                                         tabBarBackgroundColor='transparent'
                                         renderTabBar={this._renderTabBar}>
                          {this.groups.map(this._renderGroup)}
                      </ScrollableTabView>) : null}
                </View>);
    }
};

const styles = StyleSheet.create({
    tabview: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        backgroundColor: '#f9fafb',
        paddingLeft: 8,
        paddingTop: 4,
    },
    icon: {
        width: 26,
        height: 26,
        tintColor: '#666',
    },
    iconact: {
        width: 26,
        height: 26,
        //tintColor: '#5ca8fc',
        tintColor: '#fff',
    },
    imgbox: {
        marginRight: 8,
        marginBottom: 8,
    },
    image: {
        width: 26,
        height: 26,
    },
});

export default EmojiSelector;
